var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.493 9.66699H14.5096C11.4763 9.66699 9.66797 11.4753 9.66797 14.5087V21.4837C9.66797 24.5253 11.4763 26.3337 14.5096 26.3337H21.4846C24.518 26.3337 26.3263 24.5253 26.3263 21.492V14.5087C26.3346 11.4753 24.5263 9.66699 21.493 9.66699ZM21.1263 21.1253H14.8763C14.5346 21.1253 14.2513 20.842 14.2513 20.5003C14.2513 20.1587 14.5346 19.8753 14.8763 19.8753H21.1263C21.468 19.8753 21.7513 20.1587 21.7513 20.5003C21.7513 20.842 21.468 21.1253 21.1263 21.1253ZM21.1263 16.1253H14.8763C14.5346 16.1253 14.2513 15.842 14.2513 15.5003C14.2513 15.1587 14.5346 14.8753 14.8763 14.8753H21.1263C21.468 14.8753 21.7513 15.1587 21.7513 15.5003C21.7513 15.842 21.468 16.1253 21.1263 16.1253Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA5);
export default __webpack_public_path__ + "static/media/a5.ce27ef8411dbb129ffcba259cf9a395e.svg";
export { ForwardRef as ReactComponent };